//router
import Router from './router';
//util
import ScrollToTop from './utils/ScrollToTop';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

function App() {
  const theme = createTheme();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ScrollToTop />
      <Router />
    </ThemeProvider>
  );
}

export default App;
